import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PreventExit } from "components/PreventExit";
import { useNavigation } from "contexts/notificationsContext";
import { usePreventExit } from "hooks/usePreventExit";
import { useContext, useEffect, useState, useCallback } from "react";
import { FormProvider, useForm, useFormState } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
  getEmpresaById,
  getListarPorTipoMaterial,
  getTipoMaterial,
  postEmpresasDadosCadastrais,
} from "services/modules/empresas";
import {
  IMaterial,
  IPostEmpresasDadosCadastrais,
} from "shared/interfaces/empresa";
import { DadosCadastraisForm } from "shared/interfaces/formEmpresa";

import { Save, Cancel } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import AccordionsSwitch from "components/AccordionsSwitch";
import { BarScroll } from "components/BarScroll";
import { DataNotFound } from "components/DataNotFound";
import { CadastroEmpresaContext } from "contexts/cadastroEmpresaContext";
import Select from "react-select";
import { getBrasiliaTime } from "shared/helpers/cadastroEmpresas";
import { FSelect } from "shared/interfaces/select";
import { fontsSizes } from "styles/theme";
import { listarProjetistas, IFSelect } from "services/modules/aplicabilidades";

export const SEARCH_BAR_EMPRESA_ID = "search-bar-componente-anchor";

export type TiposSelecionadosForm = {
  tiposSelecionados: Record<number, FSelect[]>;
  checkExportar: boolean;
  checkImportar: boolean;
  checkLiberar: boolean;
  projetistasValidacao: number[];
};

type FormTabelaPreco = {
  tipoSelecionados: Record<number, FSelect[]>;
};

export const CadastrosN1Form = () => {
  const { selectedItems } = useContext(CadastroEmpresaContext);

  const {
    control,
    setValue,
    handleSubmit,
    reset,
    watch,
    setError,
    getValues,
    clearErrors,
    formState,
    ...methods
  } = useForm<DadosCadastraisForm>({
    mode: "onBlur",
  });

  const formTiposSelecionados = useForm<TiposSelecionadosForm>({
    defaultValues: {
      tiposSelecionados: {},
      checkExportar: false,
      checkImportar: false,
      checkLiberar: false,
      projetistasValidacao: [],
    },
  });

  const formTabPreco = useForm<FormTabelaPreco>();

  const formStateTiposSelecionados = useFormState({
    control: formTiposSelecionados.control,
  });

  const { errors, isDirty, dirtyFields } = useFormState({ control });

  const {
    isOpenModalUnsaved,
    handleIsOpenModalUnsaved,
    handleLinkNavigateBlocked,
    handleOnCloseModalUnsavedEdit,
    linkNavigateBlocked,
    isGoBack,
  } = usePreventExit(isDirty && Object.values(dirtyFields).length > 0);

  const params = useParams();
  const { openNotification } = useNavigation();

  const [shouldGetEmpresa, setShouldGetEmpresa] = useState(false);

  const [isDisabled, setIsDisabled] = useState(false);

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [nAccordions, setNAccordions] = useState(0);
  const [mappedAccordionIdReferencias, setMappedAccordionIdReferencias] =
    useState<Record<number, number>>();
  const [mappedIdReferencias, setMappedIdReferencias] =
    useState<Record<number, string>>();

  const [listaTipoMaterial, setListaTipoMaterial] = useState<FSelect[][]>([
    [],
    [],
    [],
    [],
    [],
    [],
  ]);
  const [idTipoMaterial, setIdTipoMaterial] = useState<FSelect[]>([]);
  const [idTipoMaterialLista, setIdTipoMaterialLista] = useState<FSelect[]>([]);
  const [tiposMateriais, setTiposMateriais] = useState<IMaterial[]>([]);
  const [selectedLiberacoes, setSelectedLiberacoes] = useState<Set<number>>(
    new Set()
  );
  const [selectedTabela, setSelectedTabela] = useState<Set<number>>(new Set());

  const { setDataUltimaAtualizacao } = useContext(CadastroEmpresaContext);

  const [selectedItemsRef, setSelectedItemsRef] = useState<number[]>([]);

  const [accordionSelected, setAccordionSelected] = useState<number[]>([]);

  const [optionsReferencia, setOptionsReferencia] = useState<FSelect[]>([]);
  const [projetistasOptions, setProjetistasOptions] = useState<IFSelect[]>([]);
  const [selectedProjetistas, setSelectedProjetistas] = useState<IFSelect[]>([]);
  const [projetistasLoading, setProjetistasLoading] = useState(false);
  const [projetistasSearchTerm, setProjetistasSearchTerm] = useState("");
  const [accordionLiberarCadastrosExpanded, setAccordionLiberarCadastrosExpanded] = useState(false);
  const [accordionProjetistasExpanded, setAccordionProjetistasExpanded] = useState(false);

  const handleSwitchChange = (id: number, checked: boolean, index?: number) => {
    const newSelectedLiberacoes = new Set(selectedLiberacoes);

    if (checked) {
      newSelectedLiberacoes.add(id);
      setAccordionSelected((prevState) => [...prevState, id]);
    } else {
      const filteredSelecteds = accordionSelected.filter((item) => {
        return item !== id;
      });
      setAccordionSelected(filteredSelecteds);
      newSelectedLiberacoes.delete(id);
      setListaTipoMaterial((prev) => {
        const newArray = prev.map((arr, i) => {
          return i !== index ? arr : [];
        });
        return newArray;
      });
      const closeAccordion = {
        ...formTiposSelecionados.getValues("tiposSelecionados"),
      };
      closeAccordion[id ?? 0] = [];
      formTiposSelecionados.setValue("tiposSelecionados", closeAccordion, {
        shouldDirty: true,
      });
    }
    setSelectedLiberacoes(newSelectedLiberacoes);
  };

  const handleCheckboxChangeExportar = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    formTiposSelecionados.setValue("checkExportar", event.target.checked, {
      shouldDirty: true,
    });
  };

  const handleCheckboxChangeImportar = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    formTiposSelecionados.setValue("checkImportar", event.target.checked, {
      shouldDirty: true,
    });
  };

  const handleSwitchChangeLiberacao = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    formTiposSelecionados.setValue("checkLiberar", checked, {
      shouldDirty: true,
    });
  };

  const loadProjetistas = useCallback(async (searchTerm: string = "") => {
    try {
      setProjetistasLoading(true);
      const projetistas = await listarProjetistas();
      if (searchTerm) {
        const filtered = projetistas.filter((p) =>
          p.label.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setProjetistasOptions(filtered);
      } else {
        setProjetistasOptions(projetistas);
      }
    } catch (error) {
      console.error("Erro ao carregar projetistas:", error);
      setProjetistasOptions([]);
    } finally {
      setProjetistasLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProjetistas();
  }, [loadProjetistas]);

  async function getDadosEmpresas(idEmpresa: number) {
    try {
      const result = await getEmpresaById(idEmpresa);

      if (result) {
        const produtoNivelUmMaterialVMs =
          result.data.produtoNivelUmVM?.produtoNivelUmMaterialVMs;

        const tabelaGetVMs = result.data.tabelaPrecoVMs;
        const newSelectedtabela = new Set(selectedTabela);

        tabelaGetVMs?.forEach((p) => {
          newSelectedtabela.add(p.idTipoMaterial ?? 0);
        });
        setSelectedTabela(newSelectedtabela);

        reset({
          cepEmpresa: result.data.cep,
          complementoEmpresa: result.data.complemento,
          idCidadeEmpresa: result.data.idCidade ?? null,
          idEstadoEmpresa: result.data.idEstado ?? null,
          documentoEmpresa: result.data.cpfCnpj,
          enderecoEmpresa: result.data.endereco,
          nomeFantasiaEmpresa: result.data.nomeFantasia,
          numeroEmpresa: result.data.numero ?? null,
          idPerfilEmpresa: result.data.idPerfil,
          razaoSocialEmpresa: result.data.razaoSocial,
          ativoEmpresa: result.data.ativo,
          perfilEmpresa: result.data.idPerfil.toString(),
          referenciasAplicabilidadeVM: result.data.referenciasAplicabilidadeVM,
          produtoNivelUmVM: result.data.produtoNivelUmVM,
          abasDoPerfilSelecionado:
            result?.data.abasUtilizadasPerfil.map((item) => ({
              value: item.id,
              label: item.nome,
            })) ?? [],
          abasParaAdicionar:
            result?.data.abasDisponiveisRecursosAdicionais.map((item) => ({
              value: item.id,
              label: item.nome,
            })) ?? [],
          tipoDashboardVMs: result.data.tipoDashboardVMs,
        });

        const newTiposSelecionadosTabela = {
          ...formTabPreco.getValues("tipoSelecionados"),
        };
        tabelaGetVMs?.forEach((p) => {
          newTiposSelecionadosTabela[p.idTipoMaterial ?? 0] =
            p.idsReferencia?.map((ref) => {
              return {
                value: ref,
                label: mappedIdReferencias?.[ref] ?? "",
              };
            }) ?? [];
        });
        formTabPreco.setValue("tipoSelecionados", newTiposSelecionadosTabela);

        const newAccordionSelectedTabela: number[] = [];
        result.data?.tabelaPrecoVMs?.forEach((item) => {
          if (item) {
            newAccordionSelectedTabela.push(item?.idTipoMaterial);
          }
        });
        setAccordionSelected(newAccordionSelectedTabela);

        const newAccordionSelected: number[] = [];

        result.data.produtoNivelUmVM?.produtoNivelUmMaterialVMs?.forEach(
          (item) => {
            if (item.idTipoMaterial) {
              newAccordionSelected.push(item.idTipoMaterial);
            }
          }
        );

        setAccordionSelected(newAccordionSelected);
        formTiposSelecionados.setValue(
          "checkLiberar",
          result.data.produtoNivelUmVM?.apenasConsulta || false
        );
        formTiposSelecionados.setValue(
          "checkImportar",
          result.data.produtoNivelUmVM?.importarReferenciaMercado || false
        );
        formTiposSelecionados.setValue(
          "checkExportar",
          result.data.produtoNivelUmVM?.exportarReferenciaMercado || false
        );
        
        // Carregar projetistas de validação do backend
        const projetistasIds = result.data.produtoNivelUmVM?.projetistas || [];
        formTiposSelecionados.setValue("projetistasValidacao", projetistasIds);
        
        // Atualizar selectedProjetistas com os dados carregados
        // Aguardar carregamento dos projetistas antes de mapear
        if (projetistasIds.length > 0) {
          loadProjetistas().then(() => {
            const loadedProjetistas = projetistasIds
              .map((id) => projetistasOptions.find((p) => p.value === id))
              .filter((p): p is IFSelect => p !== undefined);
            setSelectedProjetistas(loadedProjetistas);
          });
        } else {
          setSelectedProjetistas([]);
        }
        const newTiposSelecionados = {
          ...formTiposSelecionados.getValues("tiposSelecionados"),
        };
        produtoNivelUmMaterialVMs?.forEach((p) => {
          newTiposSelecionados[p.idTipoMaterial ?? 0] =
            p.idsReferencia?.map((ref) => {
              return {
                value: ref,
                label: mappedIdReferencias?.[ref] ?? "",
              };
            }) ?? [];
        });
        formTiposSelecionados.setValue(
          "tiposSelecionados",
          newTiposSelecionados
        );
      }

      if (result && result.data) {
        const tipoMaterialVMs =
          result.data.produtoNivelUmVM?.produtoNivelUmMaterialVMs || [];

        const referenciaItems = tipoMaterialVMs.flatMap(
          (item) => item.idsReferencia || []
        );

        const selectedIds = new Set<number>(
          tipoMaterialVMs
            .map((item) => item.idTipoMaterial)
            .filter((id): id is number => id !== undefined)
        );
        setSelectedLiberacoes(selectedIds);

        setSelectedItemsRef(referenciaItems);
      }
    } catch (error: any) {
      openNotification({
        isOpen: true,
        message: error?.message,
        type: "error",
      });
    }
  }

  const handleSubmitDadosCadastrais = async (data: DadosCadastraisForm) => {
    if (selectedLiberacoes.size > 0) {
      const hasMissingReferences = Array.from(selectedLiberacoes).some(
        (idTipoMaterial) => {
          const nomesReferencia =
            formTiposSelecionados.getValues("tiposSelecionados")[
              idTipoMaterial
            ];
          return !nomesReferencia || nomesReferencia.length === 0;
        }
      );

      setIsDisabled(hasMissingReferences);

      if (hasMissingReferences) {
        openNotification({
          isOpen: true,
          message:
            "Por favor, adicione pelo menos uma referência para cada liberação selecionada.",
          type: "error",
        });
        return;
      }
    }
    setIsLoadingSubmit(true);
    try {
      const produtoNivelUmMaterialVMs = Array.from(selectedLiberacoes).map(
        (idTipoMaterial) => {
          const nomesReferencia =
            formTiposSelecionados.getValues("tiposSelecionados")[
              idTipoMaterial
            ];
          const idsReferencia = nomesReferencia.map((item) => {
            return item.value;
          });

          return {
            idTipoMaterial,
            idsReferencia,
          };
        }
      );

      const tabelaVMs = Array.from(selectedTabela).map((idTipoMaterial) => {
        const nomesReferencia =
          formTabPreco.getValues("tipoSelecionados")[idTipoMaterial];
        const idsReferencia = nomesReferencia.map((item) => {
          return item.value;
        });

        return {
          idTipoMaterial,
          idsReferencia,
        };
      });

      const transformToEmpresa = (
        data: DadosCadastraisForm
      ): IPostEmpresasDadosCadastrais => {
        return {
          idEmpresa: params.id ? Number(params.id) : 0,
          nomeFantasia: data.nomeFantasiaEmpresa,
          cpfCnpj: data.documentoEmpresa,
          cep: data.cepEmpresa,
          ativo: data.ativoEmpresa ?? false,
          complemento: data?.complementoEmpresa ?? "",
          endereco: data.enderecoEmpresa,
          idCidade: data.idCidadeEmpresa ?? null,
          idEstado: data.idEstadoEmpresa ?? null,
          idPerfil: data.idPerfilEmpresa,
          numero: data.numeroEmpresa ?? null,
          razaoSocial: data.razaoSocialEmpresa,
          abas: selectedItems,
          produtoNivelUmVM: {
            produtoNivelUmMaterialVMs: produtoNivelUmMaterialVMs,
            apenasConsulta: formTiposSelecionados.getValues("checkLiberar"),
            exportarReferenciaMercado:
              formTiposSelecionados.getValues("checkExportar"),
            importarReferenciaMercado:
              formTiposSelecionados.getValues("checkImportar"),
            projetistas: formTiposSelecionados.getValues("projetistasValidacao") || [],
          },
          tipoDashboardVMs: data.tipoDashboardVMs,
          tabelaPrecoVMs: tabelaVMs,
          dataUltimaAtualizacao: getBrasiliaTime(),
          referenciasAplicabilidadeVM: data.referenciasAplicabilidadeVM,
        };
      };

      const postData: IPostEmpresasDadosCadastrais = transformToEmpresa(data);

      if (params.id) {
        await postEmpresasDadosCadastrais(postData);
        openNotification({
          isOpen: true,
          message: "Empresa atualizada com sucesso!",
          type: "success",
        });
        formTiposSelecionados.reset({
          tiposSelecionados:
            formTiposSelecionados.getValues("tiposSelecionados"),
          checkExportar: formTiposSelecionados.getValues("checkExportar"),
          checkImportar: formTiposSelecionados.getValues("checkImportar"),
          checkLiberar: formTiposSelecionados.getValues("checkLiberar"),
        });
        setDataUltimaAtualizacao(new Date());
        return;
      }
    } catch (error: any) {
      openNotification({
        isOpen: true,
        message: error?.message,
        type: "error",
      });
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const isReferenciaMercado = () => {
    const tiposSelecionados =
      formTiposSelecionados.getValues("tiposSelecionados");

    const referenciasSelecionadas = Object.values(tiposSelecionados).flat();
    const isSelected = referenciasSelecionadas.some(
      (item) => item.value === 36
    );

    return isSelected;
  };

  const accordionsTiposMaterial = async () => {
    try {
      const result = await getTipoMaterial();

      if (result) {
        const newMappedIdReferencias: Record<number, number> = {};
        result.forEach((r, index) => {
          newMappedIdReferencias[r.idTipoMaterial] = index;
        });
        setMappedAccordionIdReferencias(newMappedIdReferencias);
        for (let i = 0; i < result.length; i++) {
          const idTipoMaterial = result[i].idTipoMaterial ?? 0;
          await fecthListarPorTiposMaterias(
            idTipoMaterial,
            newMappedIdReferencias?.[i] ?? 0
          );
        }
        setShouldGetEmpresa(true);
        setNAccordions(result.length);
        formTiposSelecionados.setValue(
          "tiposSelecionados",
          Array.from({ length: result.length }, () => [])
        );
        setTiposMateriais(result);

        const tiposMateriaisSelect = result.map((item) => ({
          value: item.idTipoMaterial,
          label: item.descricao,
        }));

        setIdTipoMaterial(tiposMateriaisSelect);
        setIdTipoMaterialLista(tiposMateriaisSelect);
      }
    } catch (error: any) {
      openNotification({
        isOpen: true,
        message: "Erro ao buscar tipos de materiais.",
        type: "error",
      });
    }
  };

  const fecthListarPorTiposMaterias = async (
    idTipoMaterial: number,
    index: number
  ) => {
    try {
      const result = await getListarPorTipoMaterial();

      if (result) {
        setOptionsReferencia(result ?? []);
        setMappedIdReferencias((prev) => {
          const newMappedRefs = { ...prev };
          result.forEach((ref) => (newMappedRefs[ref.value] = ref.label));
          return newMappedRefs;
        });
        setListaTipoMaterial((prev) => {
          const newListaTipoMaterial = prev.map((item, i) => {
            return index === i ? result : item;
          });
          console.log("newLista", newListaTipoMaterial);
          return newListaTipoMaterial;
        });
        const newTiposSelecionados = {
          ...formTiposSelecionados.getValues("tiposSelecionados"),
        };
        newTiposSelecionados[idTipoMaterial ?? 0] = [];
        formTiposSelecionados.setValue(
          "tiposSelecionados",
          newTiposSelecionados
        );
      }
    } catch (error: any) {
      openNotification({
        isOpen: true,
        message: "Erro ao listar por tipos de materiais.",
        type: "error",
      });
    }
  };

  useEffect(() => {
    const tiposSelecionados = formTiposSelecionados.watch("tiposSelecionados");

    const isDisabled =
      !tiposSelecionados ||
      Object.keys(tiposSelecionados).length === 0 ||
      Object.values(tiposSelecionados).every((arr) => arr.length === 0);

    setIsDisabled(isDisabled);
  }, [formTiposSelecionados.watch("tiposSelecionados")]);

  useEffect(() => {
    accordionsTiposMaterial();
  }, []);

  useEffect(() => {
    shouldGetEmpresa && params.id && getDadosEmpresas(Number(params.id));
  }, [params.id, shouldGetEmpresa]);

  return (
    <PreventExit
      handleIsOpenModalUnsaved={handleIsOpenModalUnsaved}
      handleLinkNavigateBlocked={handleLinkNavigateBlocked}
      isOpenModalUnsaved={isOpenModalUnsaved}
      handleOnCloseModalUnsavedEdit={handleOnCloseModalUnsavedEdit}
      linkNavigateBlocked={linkNavigateBlocked}
      isGoBack={isGoBack}
    >
      <FormProvider
        {...{
          control,
          handleSubmit,
          reset,
          setValue,
          watch,
          setError,
          getValues,
          clearErrors,
          formState,
          ...methods,
        }}
      >
        <Grid container p={1.5}>
          <Grid md={12}>
            {/* Seção 1: Toggle "Liberação dos cadastros apenas para consulta" */}
            {tiposMateriais.length > 0 && (
              <>
                <Grid container mb={3} alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <Typography
                      sx={{
                        fontSize: fontsSizes.mlarge,
                        color: "#3C90AD",
                        fontWeight: 600,
                      }}
                    >
                      Liberação dos cadastros apenas para consulta
                    </Typography>
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formTiposSelecionados.watch("checkLiberar")}
                          onChange={handleSwitchChangeLiberacao}
                        />
                      }
                      label=""
                    />
                  </Grid>
                </Grid>

                {/* Faixa informativa quando toggle ativo */}
                {formTiposSelecionados.watch("checkLiberar") && (
                  <Grid mb={3}>
                    <Alert severity="warning">
                      Os cadastros estão apenas para consulta. Para liberar edição/inclusão, desative esta opção.
                    </Alert>
                  </Grid>
                )}

                <Divider sx={{ mb: 3 }} />
              </>
            )}

            {/* Seção 2: Accordion "Liberar Cadastros" */}
            {tiposMateriais.length > 0 && (
              <Accordion
                expanded={accordionLiberarCadastrosExpanded}
                onChange={(_, expanded) => setAccordionLiberarCadastrosExpanded(expanded)}
                sx={{
                  mb: 3,
                  boxShadow: "none",
                  border: "1px solid #e0e0e0",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    "& .MuiAccordionSummary-content": {
                      alignItems: "center",
                    },
                  }}
                >
                  <Tooltip
                    title="Apresenta os recursos atuais para liberação de referências que a empresa poderá realizar edição ou inclusão para cada tipo de produto: Acabamentos, Componentes, Kits, Perfis, Superfícies ou Vidros."
                    arrow
                    placement="top"
                  >
                    <Typography
                      sx={{
                        fontSize: fontsSizes.mlarge,
                        color: "#3C90AD",
                        fontWeight: 600,
                        cursor: "help",
                      }}
                    >
                      Liberar Cadastros:
                    </Typography>
                  </Tooltip>
                </AccordionSummary>
                <AccordionDetails>
                  <BarScroll maxHeight={"50vh"}>
              {tiposMateriais.length === 0 ? (
                <Grid
                  sx={{
                    minHeight: "60vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <DataNotFound visible />
                </Grid>
              ) : (
                tiposMateriais.map((tipo, index) => (
                  <AccordionsSwitch
                    key={tipo.idTipoMaterial}
                    checked={selectedLiberacoes.has(tipo.idTipoMaterial)}
                    onChangeSwtich={(e, checked) => {
                      handleSwitchChange(tipo.idTipoMaterial, checked);
                    }}
                    descricao={tipo.descricao}
                    id={tipo.idTipoMaterial}
                  >
                    <Grid container spacing={3} mb={3} display={"flex"}>
                      {/* Select de Referências */}
                      <Grid item md={11.8}>
                        <FormControl sx={{ m: 1, width: "100%" }}>
                          <Typography
                            sx={{
                              color: "secondary",
                              fontSize: fontsSizes.medium,
                            }}
                          >
                            Referências para cadastros de produtos
                          </Typography>
                          <Select
                            isClearable={false}
                            maxMenuHeight={290}
                            menuPosition="fixed"
                            isMulti
                            key={index}
                            options={optionsReferencia}
                            value={
                              formTiposSelecionados.watch("tiposSelecionados")[
                                tipo.idTipoMaterial
                              ]
                            }
                            // FASE 05 — 2ª validação/PO 2026-07-24 (A1): "Liberar Cadastros"
                            // continua habilitado mesmo com a chave "apenas para consulta" ativa
                            // (a chave só impede a empresa de editar os cadastros de produtos).
                            onChange={(selectedOptions) => {
                              const newSelected = selectedOptions
                                ? selectedOptions.map((item) =>
                                    typeof item === "string"
                                      ? { label: item, value: item }
                                      : item
                                  )
                                : [];
                              const newTiposSelecionados = {
                                ...formTiposSelecionados.getValues(
                                  "tiposSelecionados"
                                ),
                              };
                              newTiposSelecionados[tipo.idTipoMaterial ?? 0] =
                                newSelected;
                              formTiposSelecionados.setValue(
                                "tiposSelecionados",
                                newTiposSelecionados,
                                { shouldDirty: true }
                              );
                            }}
                            placeholder="Selecione o tipo de material"
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionsSwitch>
                ))
              )}
                  </BarScroll>
                </AccordionDetails>
              </Accordion>
            )}

            {/* Separador entre seções */}
            {tiposMateriais.length > 0 && <Divider sx={{ mb: 3, mt: 1 }} />}

            {/* Seção 3: Accordion "Projetista para validação"
                FASE 05 — 2ª validação/PO 2026-07-24 (A2): oculto quando a chave
                "apenas para consulta" (checkLiberar) está ativa. */}
            {tiposMateriais.length > 0 && !formTiposSelecionados.watch("checkLiberar") && (
              <Accordion
                expanded={accordionProjetistasExpanded}
                onChange={(_, expanded) => setAccordionProjetistasExpanded(expanded)}
                sx={{
                  mb: 3,
                  boxShadow: "none",
                  border: "1px solid #e0e0e0",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    "& .MuiAccordionSummary-content": {
                      alignItems: "center",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: fontsSizes.mlarge,
                      color: "#3C90AD",
                      fontWeight: 600,
                    }}
                  >
                    Projetista para validação dos cadastros de N1
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Tooltip
                    title="Apresentar para seleção os projetistas do Cadastro de Projetistas. Toda vez que o usuário dessa empresa realizar alterações de troca de código de produto ou de alteração de status do produto para Descontinuado, ele receberá uma notificação de que o produto é usado nas tipologias do respectivo projetista."
                    arrow
                    placement="top"
                  >
                    <Box>
                      <Autocomplete
                        multiple
                        options={projetistasOptions}
                        value={projetistasOptions.filter((p) =>
                          formTiposSelecionados.watch("projetistasValidacao")?.includes(p.value)
                        )}
                        onChange={(_, newValue) => {
                          const ids = newValue.map((v) => v.value);
                          formTiposSelecionados.setValue("projetistasValidacao", ids, {
                            shouldDirty: true,
                          });
                        }}
                        onInputChange={(_, newInputValue) => {
                          setProjetistasSearchTerm(newInputValue);
                          if (newInputValue) {
                            loadProjetistas(newInputValue);
                          } else {
                            loadProjetistas();
                          }
                        }}
                        loading={projetistasLoading}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              label={option.label}
                              onDelete={() => {
                                const currentIds = formTiposSelecionados.getValues("projetistasValidacao") || [];
                                const newIds = currentIds.filter((id) => id !== option.value);
                                formTiposSelecionados.setValue("projetistasValidacao", newIds, {
                                  shouldDirty: true,
                                });
                              }}
                              sx={{
                                backgroundColor: "#3C90AD",
                                color: "#fff",
                                fontWeight: 500,
                                "& .MuiChip-deleteIcon": {
                                  color: "#fff",
                                },
                              }}
                            />
                          ))
                        }
                        PaperComponent={({ children, ...other }) => (
                          <Paper {...other} sx={{ backgroundColor: "#f5f5f5" }}>
                            {children}
                          </Paper>
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Box>
                  </Tooltip>
                </AccordionDetails>
              </Accordion>
            )}

          {tiposMateriais.length > 0 && (
            <Grid item md={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 2,
                  gap: 1,
                }}
              >
                <LoadingButton
                  variant="outlined"
                  startIcon={<Cancel />}
                  onClick={() => {
                    if (formStateTiposSelecionados.isDirty) {
                      // Recarregar dados do servidor
                      if (params.id) {
                        getDadosEmpresas(Number(params.id));
                      }
                      formTiposSelecionados.reset({
                        tiposSelecionados: {},
                        checkExportar: false,
                        checkImportar: false,
                        checkLiberar: false,
                        projetistasValidacao: [],
                      });
                    }
                  }}
                  disabled={isLoadingSubmit}
                >
                  Cancelar
                </LoadingButton>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  endIcon={<Save />}
                  onClick={handleSubmit(handleSubmitDadosCadastrais)}
                  loading={isLoadingSubmit}
                  disabled={!formStateTiposSelecionados.isDirty}
                >
                  Salvar
                </LoadingButton>
              </Box>
            </Grid>
          )}
          </Grid>
        </Grid>
      </FormProvider>
    </PreventExit>
  );
};
